// -*- coding: utf-8 -*-
import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import EmptyState from './EmptyState';

export default function ThreadList({
  threads,
  loadingThreads,
  loadingParents = false,
  isParentMode,
  selectedClass,
  parentsMap,
  selected,
  onSelect,
  roleLabels,
  useDarkWhatsApp,
  missingClassMessage = 'Önce bir şube seçin',
  emptyMessage = 'Henüz mesaj bulunmuyor',
  variant = 'desktop',
  sx,
}) {
  const showLoading = isParentMode ? (loadingParents || loadingThreads) : loadingThreads;
  const showMissingClass = isParentMode && !selectedClass;
  const isEmpty = !showLoading && threads.length === 0;

  if (showMissingClass) {
    return <EmptyState message={missingClassMessage} />;
  }

  if (showLoading) {
    const skeletonCount = variant === 'mobile' ? 6 : 8;
    return (
      <Box sx={{ px: 2, pt: 1, ...sx }}>
        {[...Array(skeletonCount)].map((_, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.25 }}>
            <Skeleton variant="circular" width={variant === 'mobile' ? 32 : 36} height={variant === 'mobile' ? 32 : 36} />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width={`${variant === 'mobile' ? 60 : 65 + (i % 3) * 8}%`} />
              <Skeleton variant="text" width={`${variant === 'mobile' ? 40 : 42 + (i % 3) * 10}%`} />
            </Box>
          </Box>
        ))}
      </Box>
    );
  }

  if (isEmpty) {
    return <EmptyState message={emptyMessage} />;
  }

  return (
    <Box sx={{ ...sx }}>
      <List dense disablePadding>
        {threads.map((t) => {
          const name = parentsMap.get(String(t.phone)) || t.name || (t.phone === '_unknown' ? 'Bilinmeyen' : 'Bilinmeyen');
          const preview = (t.body || '').slice(0, 80) + ((t.body || '').length > 80 ? '…' : '');
          const selectedStyles =
            variant === 'desktop'
              ? {
                  alignItems: 'flex-start',
                  py: 1.25,
                  '&.Mui-selected': {
                    bgcolor: useDarkWhatsApp ? 'rgba(2, 81, 68, 0.35)' : 'rgba(0,92,75,0.08)',
                    borderLeft: `4px solid ${useDarkWhatsApp ? '#025144' : '#0F766E'}`,
                  },
                }
              : { alignItems: 'flex-start', py: 1.25 };

          return (
            <ListItem key={`${t.phone}-${t.id || t.timestamp || ''}`} disablePadding sx={{ mb: 0.5 }}>
              <ListItemButton selected={selected?.phone === t.phone} onClick={() => onSelect(t)} sx={selectedStyles}>
                <ListItemText
                  primary={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>{`${t.phone} • ${name}${typeof t.total_messages === 'number' ? ' • ' + t.total_messages : ''}`}</Typography>
                      <Chip size="small" label={roleLabels[t.role] || 'Diğer'} />
                    </Box>
                  }
                  secondary={<Typography variant="caption" sx={{ color: 'text.secondary' }}>{preview}</Typography>}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
}
